import {
  TaskError,
  TaskErrorAction,
  TaskErrorRemedy,
} from './task-error.model';

export function createError(
  action: TaskErrorAction,
  remedy: TaskErrorRemedy,
  code: string,
  link: string = '/support',
): TaskError {
  return { action, remedy, code, link, show: true };
}
